/* eslint-disable react/display-name */
import Dropdown from '@/shared/crisp/Dropdown';
import Div from '@/shared/Div';
import HeadingComponent from '@/shared/Heading';
import Input from '@/shared/Input';
import TextareaInput from '@/shared/Textarea';
import Paragraph from '@/shared/Paragraph';
import { MapType } from '@/types';
import CheckboxInput from '@/shared/crisp/Checkbox';
import ButtonComponent from '@/shared/Button';
import React from 'react';
import MultiCheckboxInput from '@/shared/MultiCheckbox';

const Text = React.forwardRef((props: any, ref) => {
  const { formState, ...restProps } = props;
  return <Input {...restProps} type="text" ref={ref} errors={formState.errors} />;
});

const Number = React.forwardRef((props: any, ref) => {
  const { formState, ...restProps } = props;
  return <Input {...restProps} type="number" ref={ref} errors={formState.errors} />;
});

const DateTime = React.forwardRef((props: any, ref) => {
  const { formState, placeholder, ...restProps } = props;

  return (
    <Input
      {...restProps}
      type="datetime-local"
      ref={ref}
      className="w-full appearance-none"
      errors={formState.errors}
      value={restProps.value}
      min={new Date(new Date().getTime() + 5.5 * 60 * 60 * 1000).toISOString().slice(0, 16)}
      placeholder={placeholder}
    />
  );
});

const Select = React.forwardRef((props: any, ref) => {
  const { options = [], formState, ...restProps } = props;

  return (
    <Dropdown
      ref={ref}
      {...restProps}
      dropdownList={options}
      selectedValue={options?.[0]}
      errors={formState.errors}
      disabled={options.length === 0}
    />
  );
});

const Textarea = React.forwardRef((props: any, ref) => {
  const { formState, ...restProps } = props;
  return <TextareaInput ref={ref} {...restProps} errors={formState.errors} />;
});

const Heading = ({ label, className, id, info }: any) => {
  return (
    <Div>
      <HeadingComponent level={5} id={id} className={className}>
        {label}
      </HeadingComponent>
      <Paragraph>{info}</Paragraph>
    </Div>
  );
};

const Checkbox = React.forwardRef((props: any, ref) => {
  const { formState, value, label, ...restProps } = props;
  const createMarkup = (htmlContent: any) => {
    return { __html: htmlContent };
  };
  const hasHtml =
    typeof label === 'string' &&
    (label.includes('<a') || label.includes('<span') || label.includes('<div'));
  return (
    <CheckboxInput
      ref={ref}
      {...restProps}
      label={
        hasHtml ? (
          <span
            dangerouslySetInnerHTML={createMarkup(label)}
            onClick={(e) => {
              if (e.target instanceof HTMLElement && e.target.tagName === 'A') {
                e.stopPropagation();
              }
            }}
          />
        ) : (
          label
        )
      }
      checked={Boolean(props.value)}
      errors={formState.errors}
    />
  );
});

const Button = React.forwardRef((props: any, ref) => {
  const { formState, type, ...restProps } = props;
  return <ButtonComponent {...restProps} type={type ?? 'submit'} />;
});

const MultiCheckbox = React.forwardRef((props: any, ref) => {
  const { options = [], formState, ...restProps } = props;
  return (
    <MultiCheckboxInput options={options} ref={ref} errors={formState.errors} {...restProps} />
  );
});

const FORM_FIELDS: MapType = {
  Text,
  Select,
  Textarea,
  Heading,
  Checkbox,
  Button,
  Number,
  MultiCheckbox,
  DateTime,
};

export default FORM_FIELDS;
